(() => {
  const applyTicketPrices = () => {
    const form = document.querySelector('[data-kuf-ticket-form]');
    if (!form) return;

    const memberChoice = form.querySelector('[data-member-choice]');
    const regularChoice = form.querySelector('[data-regular-choice]');
    const memberPrice = form.querySelector('.kuf-ticket-option--member .kuf-ticket-option__price');
    const regularPrice = form.querySelector('.kuf-ticket-option--regular .kuf-ticket-option__price');
    const memberCard = form.querySelector('.kuf-ticket-option--member .kuf-ticket-option__card');

    if (memberChoice) memberChoice.dataset.ticketPrice = '100 kr';
    if (regularChoice) regularChoice.dataset.ticketPrice = '350 kr';
    if (memberPrice) memberPrice.innerHTML = '100 <small>kr</small>';
    if (regularPrice) regularPrice.innerHTML = '350 <small>kr</small>';

    if (memberCard && !memberCard.querySelector('.kuf-ticket-option__saving')) {
      const saving = document.createElement('span');
      saving.className = 'kuf-ticket-option__saving';
      saving.textContent = 'Spara 71 % på kickoffbiljetten';
      const select = memberCard.querySelector('.kuf-ticket-option__select');
      if (select) select.insertAdjacentElement('beforebegin', saving);
      else memberCard.appendChild(saving);
    }

    const selected = form.querySelector('input[type="radio"][name="id"]:checked');
    const summary = form.querySelector('[data-ticket-summary]');
    if (selected && summary) {
      const memberNumber = form.dataset.memberNumber || '';
      const suffix = selected === memberChoice && memberNumber ? ` · ${memberNumber}` : '';
      summary.textContent = `${selected.dataset.ticketLabel || ''} · ${selected.dataset.ticketPrice || ''}${suffix}`;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyTicketPrices, { once: true });
  } else {
    applyTicketPrices();
  }
})();
